import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { Button, Chip } from "@heroui/react"
import { faAngleDoubleDown, faArrowDown, faArrowDown19, faChevronDown, faCircleChevronDown, faPlusMinus, faSortDown, faSquareCaretDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { LayoutContext } from "../../contexts/LayoutContext.jsx"
import { sideNavLinks } from "../../constants/enum.js"
import SideNavItem from "./SideNavItem.jsx"


function SideNav() {
  const { showSideNav } = useContext(LayoutContext)
  const { setShowSideNav } = useContext(LayoutContext)
  const { menu, user } = useSelector((state) => state.auth)
  const { isMultipleCompany } = useSelector((state) => state.company)
  const navRef = useRef()

  let userMenuComponent = useMemo(
    () =>
      menu?.userMenu?.map((item) => {
        if (item.controller !== null) return item.controller
        else return item.menuname
      })
    ,
    [menu.userMenu, user]
  )
  
  //hide side bar  when click outside of  side bar 
  const handleClickOutside = (event) => {
    if (
      navRef.current &&
      !navRef.current.contains(event.target)
    ) {
      setShowSideNav(false)
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [navRef]);

  const [show, setShow] = useState({ 0: false })
  const [showSub, setShowSub] = useState({ 0: false })
  const [showSubNest, setShowSubNest] = useState({ 0: false })
  const innerClass = "text-white uppercase  text-xs  ml-0  border-b-0 border-gray-100  hover:text-red-500"
  const iconClass = "text-xs mr-1 p-1  rounded-md border-1 border-dotted border-gray-400"

  return (
    <div ref={navRef}>
      <aside

        id="logo-sidebar"
        className={` ${!showSideNav ? "-translate-x-full" : ""
          }  fixed  lg:translate-x-0 shadow-xl shadow-slate-300 top-0 left-0 z-40 w-60 h-screen pt-10 transition-transform border-t-2 border-slate-700 
       `}
        // lg:translate-x-0 
        aria-label="Sidebar"
      >
        <div className="h-full px-1 pb-4 overflow-y-auto  bg-slate-800 text-white  
    
       ">
          {/* // shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.2)] //bg-custom-nav-bg-color bg-custom-nav-bg-color  */}
          <ul className="space-y-2 font-medium pt-4 tree  ">
            {sideNavLinks.map((item, index) => {
              return item && item.sub ? (
                userMenuComponent?.includes(item.key) ? (
                  <li key={index} className={`treeli`}>
                    <Chip
                      size="sm"
                      radius="none"
                      variant="flat"
                      startContent={
                        item && item?.icon && <FontAwesomeIcon className={`${item?.color ? item?.color : 'text-slate-800 '}
                         ${iconClass}`} icon={item.icon} />
                      }
                      endContent={<FontAwesomeIcon className="justify-end ml-2" icon={faChevronDown} />}
                      onClick={() => {
                        setShow((prev) => ({
                          // ...prev,
                          [index]: !prev[index],
                        }))
                      }}

                      className={`
                        w-full text-xs bg-slate-800 uppercase  cursor-pointer  flex justify-start  text-white  
                   `}


                    >
                      {/* bg-custom-nav-bg-color text-custom-nav-text-color  hover:bg-custom-bg-light hover:text-white */}
                      {item.name}
                    </Chip>
                    <ul
                      className={` ${show[index] ? "block" : "hidden"
                        } py-2 space-y-2`}
                    >
                      {item?.sub.map((subItem, j) => {
                        return item?.sub && subItem.sub ?
                          (userMenuComponent?.includes(subItem.key) ?
                            <li key={j} style={{ borderTop: "0px" }}>
                              <Chip
                                size="sm"
                                radius="none"
                                variant="light"
                                startContent={
                                  subItem && subItem?.icon && <FontAwesomeIcon
                                    className={` ${iconClass} text-yellow-300  `} icon={subItem.icon} />
                                }
                                endContent={<FontAwesomeIcon className=" ml-5" icon={faChevronDown} />}
                                onClick={() => {
                                  setShowSub((prev) => ({
                                    // ...prev,
                                    [j]: !prev[j],
                                  }))
                                }}

                                className="
                                ml-0 w-full uppercase  cursor-pointer  text-white   border-l-0 border-red-600  flex justify-start    
                       text-xs"
                              >
                                {/*  hover:bg-gradient-to-r from-sky-700 to-slate-50 hover:text-white bg-custom-nav-bg-color text-custom-nav-text-color  hover:bg-custom-bg-light hover:text-white */}
                                {subItem.name}
                              </Chip>

                              <ul
                                className={`${showSub[j] ? "block" : "hidden"
                                  } py-2 space-y-2`}
                              > {subItem?.sub.map((nestItem, k) => {
                                return subItem?.sub && nestItem.sub ? (userMenuComponent?.includes(nestItem.key) ?
                                  <li key={k}>
                                    <Chip
                                      size="sm"
                                      radius="none"
                                      variant="light"
                                      startContent={
                                        nestItem && nestItem?.icon && <FontAwesomeIcon className="text-orange-500 border-1 mr-1 rounded-md p-1 bg-slate-50  text-xs " icon={nestItem.icon} />
                                      }
                                      endContent={<FontAwesomeIcon className=" ml-5" icon={faChevronDown} />}
                                      onClick={() => {
                                        setShowSubNest((prev) => ({
                                          // ...prev,
                                          [k]: !prev[k],
                                        }))
                                      }}

                                      className="ml-0 w-full uppercase cursor-pointer  bg-gradient-to-r from-white to-white text-orange-500   border-l-0 border-red-600  flex justify-start    
                                                text-xs"
                                    >
                                      {nestItem.name}
                                    </Chip>
                                    <ul
                                      className={`${showSubNest[k] ? "block" : "hidden"
                                        } py-2 space-y-2`}
                                    >
                                      {nestItem?.sub.map((nestSubItem, l) => {
                                        return userMenuComponent?.includes(nestSubItem.key) ? (isMultipleCompany && (item.key == "t")) ? "" : (
                                          <SideNavItem customeclass={innerClass}
                                            navItem={nestSubItem} key={l} />
                                        ) : (
                                          ""
                                        )
                                      })}
                                    </ul>
                                  </li>
                                  : (
                                    ""
                                  ))
                                  : (
                                    userMenuComponent?.includes(nestItem.key) ? (
                                      <SideNavItem customeclass={innerClass} navItem={nestItem} key={k} />)
                                      : ("")
                                  )
                              })}
                              </ul>
                            </li>
                            : ("")) :
                          userMenuComponent?.includes(subItem.key) ? (
                            <SideNavItem customeclass={innerClass}
                              navItem={subItem} key={j} />
                            // ml-3
                          ) : (
                            ""
                          )
                      })}
                    </ul>
                  </li>
                ) : (
                  ""
                )
              ) : userMenuComponent?.includes(item.key) ? (!isMultipleCompany && (item.key == "Companies")) ? "" : (
                <SideNavItem isSingle={true} customeclass={''} navItem={item} key={index} />
              ) : (
                ""
              )
            })}
          </ul>
        </div>
      </aside>
    </div>
  )
}

export default SideNav
